/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { Contatto } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ContattoCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    Nome: "",
    Cognome: "",
    email: "",
    Telefono: "",
    Note: "",
  };
  const [Nome, setNome] = React.useState(initialValues.Nome);
  const [Cognome, setCognome] = React.useState(initialValues.Cognome);
  const [email, setEmail] = React.useState(initialValues.email);
  const [Telefono, setTelefono] = React.useState(initialValues.Telefono);
  const [Note, setNote] = React.useState(initialValues.Note);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setNome(initialValues.Nome);
    setCognome(initialValues.Cognome);
    setEmail(initialValues.email);
    setTelefono(initialValues.Telefono);
    setNote(initialValues.Note);
    setErrors({});
  };
  const validations = {
    Nome: [],
    Cognome: [],
    email: [{ type: "Email" }],
    Telefono: [],
    Note: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          Nome,
          Cognome,
          email,
          Telefono,
          Note,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new Contatto(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ContattoCreateForm")}
      {...rest}
    >
      <TextField
        label="Nome"
        isRequired={false}
        isReadOnly={false}
        value={Nome}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Nome: value,
              Cognome,
              email,
              Telefono,
              Note,
            };
            const result = onChange(modelFields);
            value = result?.Nome ?? value;
          }
          if (errors.Nome?.hasError) {
            runValidationTasks("Nome", value);
          }
          setNome(value);
        }}
        onBlur={() => runValidationTasks("Nome", Nome)}
        errorMessage={errors.Nome?.errorMessage}
        hasError={errors.Nome?.hasError}
        {...getOverrideProps(overrides, "Nome")}
      ></TextField>
      <TextField
        label="Cognome"
        isRequired={false}
        isReadOnly={false}
        value={Cognome}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Nome,
              Cognome: value,
              email,
              Telefono,
              Note,
            };
            const result = onChange(modelFields);
            value = result?.Cognome ?? value;
          }
          if (errors.Cognome?.hasError) {
            runValidationTasks("Cognome", value);
          }
          setCognome(value);
        }}
        onBlur={() => runValidationTasks("Cognome", Cognome)}
        errorMessage={errors.Cognome?.errorMessage}
        hasError={errors.Cognome?.hasError}
        {...getOverrideProps(overrides, "Cognome")}
      ></TextField>
      <TextField
        label="Email"
        isRequired={false}
        isReadOnly={false}
        value={email}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Nome,
              Cognome,
              email: value,
              Telefono,
              Note,
            };
            const result = onChange(modelFields);
            value = result?.email ?? value;
          }
          if (errors.email?.hasError) {
            runValidationTasks("email", value);
          }
          setEmail(value);
        }}
        onBlur={() => runValidationTasks("email", email)}
        errorMessage={errors.email?.errorMessage}
        hasError={errors.email?.hasError}
        {...getOverrideProps(overrides, "email")}
      ></TextField>
      <TextField
        label="Telefono"
        isRequired={false}
        isReadOnly={false}
        value={Telefono}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Nome,
              Cognome,
              email,
              Telefono: value,
              Note,
            };
            const result = onChange(modelFields);
            value = result?.Telefono ?? value;
          }
          if (errors.Telefono?.hasError) {
            runValidationTasks("Telefono", value);
          }
          setTelefono(value);
        }}
        onBlur={() => runValidationTasks("Telefono", Telefono)}
        errorMessage={errors.Telefono?.errorMessage}
        hasError={errors.Telefono?.hasError}
        {...getOverrideProps(overrides, "Telefono")}
      ></TextField>
      <TextField
        label="Note"
        isRequired={false}
        isReadOnly={false}
        value={Note}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Nome,
              Cognome,
              email,
              Telefono,
              Note: value,
            };
            const result = onChange(modelFields);
            value = result?.Note ?? value;
          }
          if (errors.Note?.hasError) {
            runValidationTasks("Note", value);
          }
          setNote(value);
        }}
        onBlur={() => runValidationTasks("Note", Note)}
        errorMessage={errors.Note?.errorMessage}
        hasError={errors.Note?.hasError}
        {...getOverrideProps(overrides, "Note")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
